import React, { useEffect, useState, lazy, Suspense } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./utilities/axios";
import Loading from "./components/Loading";
import RootContainer from "./careers/globals/Root";
import { RecoilRoot } from "recoil";
import { SwitchScreenProvider } from "./hooks/SwitchScreenContext";
// import ErrorPage from "./pages/ErrorPage";
import AcceptAgentInvitationPage from "./pages/Auth/AcceptAgentInvitationPage";
// import EmployeeInformation from "./pages/Operations/EmployeeInformation/EmployeeInformation";

import ChatWidget from "./chat-widget/ChatWidget";
import EmbededCode from "./chat-widget/EmbededCode";

// import EmployeeEngagement from "./pages/Operations/EmployeeEngagement/EmployeeEngagement";

import AgentDashboard from "./dashboard/AgentDashboard";

import ProtectedRoute from "./components/ProtectedRoute";
import { CssBaseline } from "@mui/material";

const Header = lazy(() => import("./components/Header"));
const Home = lazy(() => import("./pages/Home"));
const SignupTrial = lazy(() => import("./pages/SignupTrial"));
const TrialActivate = lazy(() => import("./pages/TrialActivate"));

const Login = lazy(() => import("./pages/Login"));
const Signup = lazy(() => import("./pages/Signup"));


const Footer = lazy(() => import("./pages/Footer"));


// const AuthorizationProvider = lazy(() => import("./hooks/Authorize"));
const ThemeContextProvider = lazy(() => import("./style/theme"));
const CreateOrganization = lazy(() =>
  import("./pages/Organization/CreateOrganization")
);
const ListOrganization = lazy(() =>
  import("./pages/Organization/ListOrganization")
);
const EditOrganization = lazy(() =>
  import("./pages/Organization/EditOrganization")
);
const OrganizationInvitation = lazy(() => 
  import("./pages/Organization/OrganizationInvitation")
);
// const OnBoarding = lazy(() => import("./pages/OnBoarding/OnBoarding"));
const Theme = lazy(() => import("./pages/admin/Theme"));

const Layout = lazy(() => import("./Layout"));
const ChatPage = lazy(() => import("./pages/Chat/ChatPage"));
const Generalsettinghome = lazy(() => import("./pages/admin/Generalsettinghome"));



const defaultConfig = {
  organizationId: "683c655f900140fa24d3336e",
  widgetId: "683c655f900140fa24d3336e",
  name: "Support Chat",
  position: "bottom-right",
  greetingMessage: "Hello! How can we help you?",
  welcomeButtonText: "💬",
  headerColor: "#007bff",
  buttonColor: "#007bff",
  userMessageColor: "#007bff",
  userMessageTextColor: "#fff",
  agentMessageColor: "#eee",
  agentMessageTextColor: "#333",
  widgetBackgroundColor: "#fff",
  fontFamily: "sans-serif",
  requirePreChatForm: true,
  isOffline: false,
  offlineMessage: "We're currently offline. Please leave a message!",
  autoRespondOffline: true,
  offlineAutoResponseMessage: "Thanks for your message! We'll get back to you soon."
};

const config = (typeof window !== "undefined" && window.$mychat && window.$mychat.config)
  ? window.$mychat.config
  : defaultConfig;

const finalConfig =
  config ||
  (typeof window !== "undefined" && window.$mychat && window.$mychat.config) ||
  defaultConfig;

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [careerUser, setCareerUser] = useState(null);
  const [switchScreen, setSwitchScreen] = useState({
    primary: "trackOnboarding",
  });
  let currentOrg = JSON.parse(localStorage.getItem("org"));

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const data = {
      amount: queryParams.get("amount"),
      period: queryParams.get("period"),
      theme: queryParams.get("theme"),
    };

    if (data.amount !== null || data.period !== null) {
      localStorage.setItem("planData", JSON.stringify(data));
    }
  }, [location]);

  const operationRoutes =
    currentOrg?.type == "Owner" ?
      [
     
      ] : [
        // { path: "operations/leave-Tracker", element: <LeaveTracker /> },
      ];

  if (location.pathname === "/register") {
    return (
      <ThemeContextProvider>
        <CssBaseline />
        <Suspense fallback={<Loading />}>
          <SignupTrial />
        </Suspense>
      </ThemeContextProvider>
    );
  }

  if (location.pathname === "/register/trialactivate") {
    return (
      <ThemeContextProvider>
        <CssBaseline />
        <Suspense fallback={<Loading />}>
          <TrialActivate />
        </Suspense>
      </ThemeContextProvider>
    );
  }

 
 if (location.pathname === "/login") {
   return (
     <ThemeContextProvider>
       <CssBaseline />
       <Suspense fallback={<Loading />}>
         <Login />
       </Suspense>
     </ThemeContextProvider>
   );
 }

 if (location.pathname === "/signup") {
   return (
     <ThemeContextProvider>
       <CssBaseline />
       <Suspense fallback={<Loading />}>
         <Signup />
       </Suspense>
     </ThemeContextProvider>
   );
 }

  if (location.pathname.startsWith("/career")) {
    return (
      <Suspense fallback={<Loading />}>
        <RecoilRoot>
          <RootContainer careerUser={careerUser} setCareerUser={setCareerUser}>
            <Routes>
              <Route path="/career/:organization">
                {/* <Route index element={<CareerHome />} />
                <Route path="apply-for-job/:id" element={<ApplyForJob setCareerUser={setCareerUser} />} />
                <Route path="job/:id" element={<JobDetails />} /> */}
              </Route>
              {/* <Route path="/career/404" element={<ErrorPage />} /> */}
            </Routes>
          </RootContainer>
        </RecoilRoot>
      </Suspense>
    );
  }

  return (
    <>
      <SwitchScreenProvider>
        <Suspense fallback={<Loading />}>
          <Header>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="dashboard/mySpace" element={<Home />} />
                <Route path="dashboard/team" element={<Home />} />
                <Route path="dashboard/organization" element={<Home />} />
                <Route path="accept-agent-invite" element={<AcceptAgentInvitationPage />} />


                {operationRoutes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
        <Route path="/widget" element={<ProtectedRoute><ChatWidget config={finalConfig} /></ProtectedRoute>} />
        <Route path="/chat/dashboard" element={<ProtectedRoute><AgentDashboard  /></ProtectedRoute>} />
                {/* <Route path="onboarding/candidate" element={currentOrg?.type == "Owner" ? <Candidate /> : <OnBording />} /> */}
                {/* <Route path="operations" element={<Operations />} /> */}
                <Route path="chat/embeddedCode" element={<ProtectedRoute><EmbededCode /></ProtectedRoute>} />

                {/* <Route path="apps" element={<Apps />} /> */}


                {/* <Route path="EmployeeHome" element={<Employeelist />} /> */}
      
                <Route path="chat" element={currentOrg?.type == "Owner" ? <ChatPage /> : currentOrg?.type == "Member" ? /* <Employeechat /> */ <></> : <></>} />

                <Route path="generalsetting" element={<Generalsettinghome />} />
       

        
                {/* <Route path="checkout" element={<OnBoarding />} /> */}
                <Route
                  path="createOrganization"
                  element={<CreateOrganization />}
                />
                <Route path="listOrganization" element={<ListOrganization />} />
                <Route
                  path="organization/:id"
                  element={
                    <ProtectedRoute>
                      <OrganizationInvitation />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="EditOrganization/:id"
                  element={<EditOrganization />}
                />
                <Route path="chat-widget.iife.js" element={
                  <script src="/chat-widget.iife.js" type="text/javascript" />
                } />
              </Route>
            </Routes>
          </Header>
          {/* <Footer /> */}
        </Suspense>
      </SwitchScreenProvider>
    </>
  );
};

export default App;
